import React from 'react';
import { XCircle } from 'lucide-react';

const SessionStatusBadge = ({ status }) => {
    const baseClasses = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium';
    const statusClasses = {
        Confirmed: 'bg-blue-100 text-blue-800',
        active: 'bg-green-100 text-green-800',
        cancelled: 'bg-red-100 text-red-800',
        scheduled: 'bg-blue-100 text-blue-800',
        completed: 'bg-green-100 text-green-800', 
        missed: 'bg-orange-100 text-orange-800',
    };
    return <span className={`${baseClasses} ${statusClasses[status]} capitalize`}>{status}</span>;
};

const SessionsTable = ({ sessions, onCancel }) => {
    return (
        <div className="overflow-x-auto">
            <table className="w-full text-sm text-left text-gray-500">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                    <tr>
                        <th scope="col" className="px-6 py-3">Member</th>
                        <th scope="col" className="px-6 py-3">Trainer</th>
                        <th scope="col" className="px-6 py-3">Date </th>
                        <th scope="col" className="px-6 py-3">Start Time - End Time</th>
                        <th scope="col" className="px-6 py-3">Status</th>
                        {onCancel && <th scope="col" className="px-6 py-3 text-right">Actions</th>}
                    </tr>
                </thead>
                <tbody>
                    {sessions.map(session => (
                        <tr key={session.id} className="bg-white border-b hover:bg-gray-50">
                            <td className="px-6 py-4 font-medium text-gray-900">
                                <div className='font-bold'>{session?.user?.name ?? session?.user_id}</div>
                                <div className='font-light text-gray-500'>{session?.user?.member_id ?? '--'}</div>
                            </td>
                            <td className="px-6 py-4">{session?.trainer?.name ?? session?.trainer_id}</td>
                            <td className="px-6 py-4">  {session?.date ?? '--'} </td> 
                            <td className="px-6 py-4">  {`${session?.start_time} - ${session?.end_time}`} </td> 
                            <td className="px-6 py-4">
                                <SessionStatusBadge status={session.status} />
                            </td>
                            {(onCancel && session.status == 'scheduled') &&(
                                <td className="px-6 py-4 text-right">
                                    <button onClick={() => onCancel(session)} title="Cancel Session" className="p-2 text-red-500 hover:bg-red-100 rounded-full transition-colors">
                                        <XCircle size={18} />
                                    </button>
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
            {sessions.length === 0 && (
                <div className="text-center py-12 text-gray-500">
                    <p>No sessions found.</p>
                </div>
            )}
        </div>
    );
};

export default SessionsTable;
